module.exports = __webpack_public_path__ + "static/brand03-1f80a763ace65ea6f3373d50ddb56a32.png";